import { DatePicker, Select, Skeleton } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";
import { ColumnChart, FilterBar } from "./chartUtils";
dayjs.extend(customParseFormat);

const { Option } = Select;

function TicketByProject() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [defaultYear, setDefaultYear] = useState(dayjs());
    const [formData, setFormData] = useState({
        staff_id,
        workauthor_id: "",
        range_year: defaultYear.get("year"),
    });
    const [assignee, setAssignee] = useState([]);
    const [chartData, setChartData] = useState([]);

    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "ticketByProjects",
        async () =>
            await HTTP("/analytics/geJiraTicketsByProjects", { ...formData }),
        { enabled: false },
    );

    const {
        status: assigneeStatus,
        data: assigneeRes,
        refetch: fetchWorkLogAuthor,
    } = useQuery(
        "assignee",
        async () => await HTTP("/analytics/getJiraAssignees", { staff_id }),
        { enabled: false },
    );

    useEffect(() => {
        if (assigneeStatus === "success") setAssignee(assigneeRes.data);
    }, [assigneeStatus, assigneeRes]);

    useEffect(() => {
        getChart();
        fetchWorkLogAuthor();
    }, []);

    useEffect(() => {
        if (chartStatus === "success") setChartData(chartRes.data);
    }, [chartStatus, chartRes]);

    useEffect(() => {
        getChart();
    }, [formData]);

    function handleYearChange(_, dateString) {
        setDefaultYear(dateString === "" ? dayjs() : dayjs(dateString));
        setFormData((prev) => ({
            ...prev,
            range_year: dateString || dayjs().get("year"),
        }));
    }

    function handleAssigneeSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            workauthor_id: e ? e.split("#")[0] : "",
        }));
    }

    const isReady = chartStatus !== "loading" && chartStatus !== "idle";

    return (
        <>
            <FilterBar>
                <DatePicker
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                    style={{ width: 120 }}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Work-log Author"
                    onChange={handleAssigneeSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </FilterBar>
            {isReady && chartData.length > 0 ? (
                <ColumnChart rawData={chartData} height={560} stacked />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 10, width: "100%" }}
                />
            )}
        </>
    );
}

export default TicketByProject;
